import { useTranslation } from 'react-i18next'
import UploadFlightData from './UploadFlightData'
import './index.scss'
import leftArrow from '../../assets/images/chevronLeft.svg';
import { USER_PRIVLILEGES } from '../../constants'
import getPrincipal from '../../utils/getPrincipal'



const ScheduleVisualization = ({ showErrorPopup }) => {
	//for multilingual
	const { t, i18n } = useTranslation(['labels'])

	const getDashboardUrl = (userDetails) => {
		const isEnterprise = userDetails?.type === "enterprise";
		const isGSA = userDetails?.roles?.includes(USER_PRIVLILEGES.GSA_USER_PRIVILEGE);
		const env = process.env.REACT_APP_ENV;
		if (isEnterprise || isGSA) {
			return (env === 'stage' || env === 'dev')
				? `https://test.etihadcargo.com/${i18n.language}/secured/dashboard`
				: `https://etihadcargo.com/${i18n.language}/secured/dashboard`;
		}
		return '/dashboard';
	};

	const backButtonClickHandler = () => {
		const userDetails = getPrincipal();
		window.location.href = getDashboardUrl(userDetails);
	};

	return (
		<>
			<div className='schedule-visualization-container'>
				<div className="sv-header-section">
					<div className="back-section">
						<img src={leftArrow} alt='left' title='back-btn' />
						<div
							className="back-label"
							onClick={backButtonClickHandler}
						>{t('SCHEDULE_VISUALIZATION.BACK_LABEL')}</div>
					</div>
					<label className="sv-heading">{t('SCHEDULE_VISUALIZATION.HEADING')}</label>
				</div>
				<UploadFlightData />
			</div>
		</>
	)
}

export default ScheduleVisualization
